// extracted by mini-css-extract-plugin
export default {"container":"locale-selector_container__7QfRj","locale":"locale-selector_locale__nnh8n","active":"locale-selector_active__Qgr94"};